import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_PUBLIC_MANUAL_INVOICE_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpPartialSuccess, hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type {
  GetPublicInvoiceManualPayload,
  GetPublicInvoiceManualResult,
  PublicManualBill,
} from '../types/getPublicManualBill.types';

export const getPublicInvoiceManual = (builder: BuilderType) =>
  builder.query<PublicManualBill, GetPublicInvoiceManualPayload>({
    query: (data) => ({
      data,
      method: 'POST',
      url: GET_PUBLIC_MANUAL_INVOICE_URL,
    }),
    transformResponse: (response: GenericApiResponse<GetPublicInvoiceManualResult>) => {
      if (hasCcdpSuccess(response) || hasCcdpPartialSuccess(response)) {
        return response.Result.ManualBill;
      }
      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
